export default "__VITE_ASSET__0935af34__"